import React, { useEffect, useState, createElement } from 'react';
import { CheckCircleIcon, XCircleIcon, ChevronDownIcon, ChevronUpIcon, ShieldCheckIcon, ZapIcon, DownloadIcon, StarIcon, ArrowRightIcon, LockIcon, ClockIcon, TrendingUpIcon, AlertTriangleIcon, FileTextIcon, CalculatorIcon, MessageSquareIcon, ClipboardListIcon } from 'lucide-react';
type FAQItem = {
  question: string;
  answer: string;
};
const faqs: FAQItem[] = [{
  question: '¿Necesito saber mucho de computadoras?',
  answer: 'No, el sistema está diseñado para usarse desde el teléfono con herramientas simples que ya conoces. Si puedes usar WhatsApp, puedes usar este sistema.'
}, {
  question: '¿Funciona para cualquier estado de USA?',
  answer: 'Sí, los principios de costos y márgenes son universales para la industria en todo el país. El Protocolo 30/30/40 aplica en California, Texas, Florida, Nueva York y cualquier otro estado.'
}, {
  question: '¿Qué pasa si mis materiales cuestan más del 30%?',
  answer: 'El manual te enseña a ajustar el precio total para que tu ganancia nunca se vea afectada por el mercado. Aprenderás a repercutir los costos correctamente sin perder el contrato.'
}, {
  question: '¿Es un pago único?',
  answer: 'Sí, un solo pago de $47 por acceso de por vida a todo el material. Sin suscripciones, sin cobros ocultos, sin sorpresas.'
}];
// Extend Window type for fbq
declare global {
  interface Window {
    fbq: (...args: unknown[]) => void;
    _fbq: unknown;
  }
}
export function SalesPage() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  const [isScrolled, setIsScrolled] = useState(false);
  const [openModal, setOpenModal] = useState<'privacy' | 'terms' | null>(null);
  const [timeLeft, setTimeLeft] = useState(600);
  const [tick, setTick] = useState(false);
  // Countdown timer - runs once on mount
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 1) return 600; // reset for urgency loop
        return prev - 1;
      });
      setTick(t => !t);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const minutes = String(Math.floor(timeLeft / 60)).padStart(2, '0');
  const seconds = String(timeLeft % 60).padStart(2, '0');
  const isUrgent = timeLeft <= 60;
  // Meta Pixel: init + PageView on mount
  useEffect(() => {
    // Inject Meta Pixel script
    if (!document.getElementById('meta-pixel-script')) {
      const script = document.createElement('script');
      script.id = 'meta-pixel-script';
      script.async = true;
      script.innerHTML = `
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '790218720565321');
        fbq('track', 'PageView');
      `;
      document.head.appendChild(script);
    } else {
      // Pixel already loaded, just fire PageView
      if (typeof window.fbq === 'function') {
        window.fbq('track', 'PageView');
      }
    }
  }, []);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 100);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const toggleFaq = (index: number) => {
    setOpenFaq(openFaq === index ? null : index);
  };
  const handleCTA = () => {
    window.scrollTo({
      top: document.body.scrollHeight,
      behavior: 'smooth'
    });
  };
  const handleAddToCart = () => {
    if (typeof window.fbq === 'function') {
      window.fbq('track', 'AddToCart', {
        content_name: 'Contratista Master',
        content_ids: ['48931418341616'],
        content_type: 'product',
        value: 6.35,
        currency: 'USD'
      });
    }
  };
  return <div className="w-full min-h-screen" style={{
    backgroundColor: '#0F172A',
    fontFamily: 'Inter, sans-serif'
  }} data-id="element-2">
      <style data-id="element-3">{`
        @keyframes flash-border {
          0%, 100% { border-color: #EF4444; box-shadow: 0 0 20px rgba(239,68,68,0.5); }
          50% { border-color: #FCA5A5; box-shadow: 0 0 40px rgba(239,68,68,0.9); }
        }
        @keyframes digit-pulse {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.05); }
        }
        @keyframes banner-flash {
          0%, 100% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
        }
      `}</style>

      {/* STICKY TOP BAR */}
      <div className="w-full py-2 px-4 text-center text-sm font-medium z-50 sticky top-0" style={{
      backgroundColor: '#1E293B',
      borderBottom: '1px solid #F59E0B',
      fontFamily: 'Inter, sans-serif'
    }} data-id="element-4">
        <span className="text-white" data-id="element-5">
          🔒{' '}
          <span style={{
          color: '#F59E0B'
        }} data-id="element-6">
            Pago Seguro
          </span>{' '}
          |{' '}
          <span style={{
          color: '#F59E0B'
        }} data-id="element-7">
            Acceso Inmediato
          </span>{' '}
          |{' '}
          <span style={{
          color: '#F59E0B'
        }} data-id="element-8">
            Garantía de Satisfacción
          </span>
        </span>
      </div>

      {/* COUNTDOWN BANNER */}
      <div className="w-full px-4 py-4 relative overflow-hidden" style={{
      background: isUrgent ? 'linear-gradient(135deg, #450a0a 0%, #7f1d1d 30%, #991b1b 50%, #7f1d1d 70%, #450a0a 100%)' : 'linear-gradient(135deg, #451a03 0%, #78350f 30%, #92400e 50%, #78350f 70%, #451a03 100%)',
      borderTop: `3px solid ${isUrgent ? '#EF4444' : '#F59E0B'}`,
      borderBottom: `3px solid ${isUrgent ? '#EF4444' : '#F59E0B'}`
    }} data-id="element-9">
        {/* Animated background shimmer */}
        <div className="absolute inset-0 opacity-20" style={{
        backgroundImage: 'repeating-linear-gradient(90deg, transparent, transparent 40px, rgba(255,255,255,0.05) 40px, rgba(255,255,255,0.05) 41px)'
      }} data-id="element-10" />
        <div className="max-w-3xl mx-auto relative z-10" data-id="element-11">
          {/* Top label */}
          <div className="text-center mb-3" data-id="element-12">
            <span className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-widest" style={{
            color: isUrgent ? '#FCA5A5' : '#FCD34D',
            fontFamily: 'Oswald, sans-serif',
            letterSpacing: '0.2em'
          }} data-id="element-13">
              <ZapIcon className="w-3.5 h-3.5" data-id="element-14" />
              {isUrgent ? '⚠️ ¡ÚLTIMA OPORTUNIDAD! OFERTA A PUNTO DE EXPIRAR' : '🔥 OFERTA ESPECIAL DE LANZAMIENTO — PRECIO EXCLUSIVO HOY'}
              <ZapIcon className="w-3.5 h-3.5" data-id="element-15" />
            </span>
          </div>

          {/* Main countdown row */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-16">
            <div className="text-center" data-id="element-17">
              <p className="text-sm font-semibold mb-2" style={{
              color: isUrgent ? '#FCA5A5' : '#FCD34D',
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-18">
                Esta oferta expira en:
              </p>
              {/* Digit blocks */}
              <div className="flex items-center gap-1.5" data-id="element-19">
                {/* Minutes */}
                <div className="flex gap-1" data-id="element-20">
                  {minutes.split('').map((d, i) => <div key={`m${i}`} className="flex items-center justify-center rounded-lg" style={{
                  width: '52px',
                  height: '64px',
                  backgroundColor: isUrgent ? '#7F1D1D' : '#0F172A',
                  border: `2px solid ${isUrgent ? '#EF4444' : '#F59E0B'}`,
                  boxShadow: isUrgent ? '0 0 16px rgba(239,68,68,0.6), inset 0 1px 0 rgba(255,255,255,0.1)' : '0 0 16px rgba(245,158,11,0.4), inset 0 1px 0 rgba(255,255,255,0.1)',
                  animation: isUrgent ? 'flash-border 0.8s ease-in-out infinite' : 'none'
                }} data-id="element-21">
                      <span style={{
                    fontFamily: 'Oswald, sans-serif',
                    fontSize: '2.2rem',
                    fontWeight: 800,
                    color: isUrgent ? '#FCA5A5' : '#F59E0B',
                    lineHeight: 1,
                    animation: tick ? 'digit-pulse 0.1s ease-out' : 'none'
                  }} data-id="element-22">
                        {d}
                      </span>
                    </div>)}
                </div>

                {/* Colon */}
                <div className="flex flex-col gap-2 pb-1" data-id="element-23">
                  <div className="w-2 h-2 rounded-full" style={{
                  backgroundColor: isUrgent ? '#EF4444' : '#F59E0B',
                  opacity: tick ? 1 : 0.3
                }} data-id="element-24" />
                  <div className="w-2 h-2 rounded-full" style={{
                  backgroundColor: isUrgent ? '#EF4444' : '#F59E0B',
                  opacity: tick ? 0.3 : 1
                }} data-id="element-25" />
                </div>

                {/* Seconds */}
                <div className="flex gap-1" data-id="element-26">
                  {seconds.split('').map((d, i) => <div key={`s${i}`} className="flex items-center justify-center rounded-lg" style={{
                  width: '52px',
                  height: '64px',
                  backgroundColor: isUrgent ? '#7F1D1D' : '#0F172A',
                  border: `2px solid ${isUrgent ? '#EF4444' : '#F59E0B'}`,
                  boxShadow: isUrgent ? '0 0 16px rgba(239,68,68,0.6), inset 0 1px 0 rgba(255,255,255,0.1)' : '0 0 16px rgba(245,158,11,0.4), inset 0 1px 0 rgba(255,255,255,0.1)',
                  animation: isUrgent ? 'flash-border 0.8s ease-in-out infinite' : 'none'
                }} data-id="element-27">
                      <span style={{
                    fontFamily: 'Oswald, sans-serif',
                    fontSize: '2.2rem',
                    fontWeight: 800,
                    color: isUrgent ? '#FCA5A5' : '#F59E0B',
                    lineHeight: 1
                  }} data-id="element-28">
                        {d}
                      </span>
                    </div>)}
                </div>
              </div>
              {/* Labels */}
              <div className="flex items-center mt-1.5" style={{
              paddingLeft: '2px'
            }} data-id="element-29">
                <span className="text-xs uppercase tracking-widest" style={{
                color: '#64748B',
                width: '108px',
                textAlign: 'center',
                fontFamily: 'Inter, sans-serif'
              }} data-id="element-30">
                  Minutos
                </span>
                <span className="w-5" data-id="element-31" />
                <span className="text-xs uppercase tracking-widest" style={{
                color: '#64748B',
                width: '108px',
                textAlign: 'center',
                fontFamily: 'Inter, sans-serif'
              }} data-id="element-32">
                  Segundos
                </span>
              </div>
            </div>

            {/* Price teaser */}
            <div className="text-center px-5 py-3 rounded-xl" style={{
            backgroundColor: 'rgba(0,0,0,0.3)',
            border: `1px solid ${isUrgent ? 'rgba(239,68,68,0.4)' : 'rgba(245,158,11,0.3)'}`
          }} data-id="element-33">
              <p className="text-xs uppercase tracking-wider mb-1" style={{
              color: '#94A3B8',
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-34">
                Precio especial hoy
              </p>
              <div className="flex items-center gap-2 justify-center" data-id="element-35">
                <span className="text-sm line-through" style={{
                color: '#64748B',
                fontFamily: 'Oswald, sans-serif'
              }} data-id="element-36">
                  $49.99
                </span>
                <span className="text-3xl font-bold" style={{
                fontFamily: 'Oswald, sans-serif',
                color: '#F59E0B'
              }} data-id="element-37">
                  $6.35
                </span>
              </div>
              <div className="mt-1 px-2 py-0.5 rounded text-xs font-bold uppercase" style={{
              backgroundColor: '#EF4444',
              color: '#FFFFFF',
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-38">
                87% DE DESCUENTO
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* HERO SECTION */}
      <section className="w-full px-4 pt-10 pb-16 relative overflow-hidden" style={{
      background: 'linear-gradient(180deg, #0F172A 0%, #1E293B 50%, #0F172A 100%)'
    }} data-id="element-39">
        {/* Background grid pattern */}
        <div className="absolute inset-0 opacity-5" style={{
        backgroundImage: 'linear-gradient(#F59E0B 1px, transparent 1px), linear-gradient(90deg, #F59E0B 1px, transparent 1px)',
        backgroundSize: '40px 40px'
      }} data-id="element-40" />

        <div className="max-w-3xl mx-auto relative z-10" data-id="element-41">
          {/* Urgency Badge */}
          <div className="flex justify-center mb-6" data-id="element-42">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-bold uppercase tracking-wider" style={{
            backgroundColor: '#F59E0B',
            color: '#0F172A',
            fontFamily: 'Oswald, sans-serif'
          }} data-id="element-43">
              <ZapIcon className="w-4 h-4" data-id="element-44" />
              PRECIO DE LANZAMIENTO — OFERTA LIMITADA
            </div>
          </div>

          {/* H1 */}
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-center leading-tight mb-2 uppercase" style={{
          fontFamily: 'Oswald, sans-serif',
          fontWeight: 800,
          color: '#FFFFFF'
        }} data-id="element-45">
            Deja de trabajar gratis
            <br data-id="element-46" />
            para tus clientes:
          </h1>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-center leading-tight mb-6 uppercase" style={{
          fontFamily: 'Oswald, sans-serif',
          fontWeight: 800,
          color: '#F59E0B'
        }} data-id="element-47">
            El Sistema de Blindaje
            <br data-id="element-48" />
            para Contratistas
          </h1>

          {/* H2 */}
          <p className="text-lg md:text-xl text-center mb-10 leading-relaxed max-w-2xl mx-auto" style={{
          color: '#CBD5E1',
          fontFamily: 'Inter, sans-serif',
          fontWeight: 400
        }} data-id="element-49">
            El{' '}
            <strong style={{
            color: '#F59E0B'
          }} data-id="element-50">
              Protocolo 30/30/40
            </strong>{' '}
            para asegurar un margen neto del 30% en cada proyecto,{' '}
            <strong style={{
            color: '#FFFFFF'
          }} data-id="element-51">
              sin perder contratos por "precio alto".
            </strong>
          </p>

          {/* Product Mockup */}
          <div className="flex justify-center mb-10" data-id="element-52">
            <div className="relative" style={{
            filter: 'drop-shadow(0 20px 60px rgba(245, 158, 11, 0.25))'
          }} data-id="element-53">
              <img src="https://cdn.magicpatterns.com/uploads/dR46B7XDc1whSqG6HM1ksp/Mockup_Contratista_Master.png" alt="Manual Contratista Master - Control de Costos y Ganancia Real" className="w-full max-w-xs md:max-w-sm rounded-xl" data-id="element-54" />
            </div>
          </div>

          {/* Hero CTA */}
          <div className="flex flex-col items-center gap-4" data-id="element-55">
            <button onClick={handleCTA} className="w-full max-w-md py-5 px-8 rounded-xl text-xl font-bold uppercase tracking-wide transition-all duration-200 active:scale-95 cta-pulse" style={{
            backgroundColor: '#F59E0B',
            color: '#0F172A',
            fontFamily: 'Oswald, sans-serif',
            fontWeight: 800,
            fontSize: '1.25rem',
            letterSpacing: '0.05em'
          }} data-id="element-56">
              QUIERO SER UN CONTRATISTA MASTER →
            </button>
            <div className="flex items-center gap-2 text-sm" style={{
            color: '#94A3B8'
          }} data-id="element-57">
              <LockIcon className="w-4 h-4" style={{
              color: '#22C55E'
            }} data-id="element-58" />
              <span data-id="element-59">
                Acceso inmediato tras la compra. Pago seguro y encriptado.
              </span>
            </div>
          </div>
        </div>
      </section>

      {/* AMBER DIVIDER */}
      <div className="w-full h-1" style={{
      background: 'linear-gradient(90deg, transparent, #F59E0B, transparent)'
    }} data-id="element-60" />

      {/* OPENING HOOK / STORY */}
      <section className="w-full px-4 py-14" style={{
      backgroundColor: '#1E293B'
    }} data-id="element-61">
        <div className="max-w-2xl mx-auto" data-id="element-62">
          <div className="text-xs font-bold uppercase tracking-widest mb-4 text-center" style={{
          color: '#F59E0B',
          fontFamily: 'Oswald, sans-serif'
        }} data-id="element-63">
            ¿Te suena familiar?
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-8 uppercase" style={{
          fontFamily: 'Oswald, sans-serif',
          color: '#FFFFFF'
        }} data-id="element-64">
            Es viernes por la tarde...
          </h2>

          <div className="rounded-xl p-6 md:p-8 border-l-4 mb-8" style={{
          backgroundColor: '#0F172A',
          borderLeftColor: '#F59E0B'
        }} data-id="element-65">
            <p className="text-base md:text-lg leading-relaxed mb-4" style={{
            color: '#CBD5E1'
          }} data-id="element-66">
              Acabas de terminar una obra de dos semanas. Tienes el cheque final
              en la mano, pero{' '}
              <strong style={{
              color: '#FFFFFF'
            }} data-id="element-67">
                el nudo en el estómago no se quita.
              </strong>
            </p>
            <p className="text-base md:text-lg leading-relaxed" style={{
            color: '#CBD5E1'
          }} data-id="element-68">
              Ya sacaste la cuenta: después de pagar los materiales que subieron
              de precio, las dos vueltas extra al Home Depot y el sueldo de tus
              ayudantes,{' '}
              <strong style={{
              color: '#F59E0B',
              fontSize: '1.1em'
            }} data-id="element-69">
                a ti te quedan apenas $300 dólares.
              </strong>{' '}
              Has trabajado 60 horas esta semana para ganar menos que un
              empleado principiante.
            </p>
          </div>

          <div className="rounded-xl p-6 border" style={{
          backgroundColor: '#0F172A',
          borderColor: '#2D3F55'
        }} data-id="element-70">
            <div className="flex items-start gap-3 mb-4" data-id="element-71">
              <AlertTriangleIcon className="w-6 h-6 flex-shrink-0 mt-1" style={{
              color: '#F59E0B'
            }} data-id="element-72" />
              <p className="text-base md:text-lg leading-relaxed" style={{
              color: '#CBD5E1'
            }} data-id="element-73">
                La mayoría de los contratistas hispanos en Estados Unidos no
                tienen un problema de falta de trabajo, tienen un problema de{' '}
                <strong style={{
                color: '#F59E0B'
              }} data-id="element-74">
                  "ceguera de costos"
                </strong>
                . Calculan sus presupuestos "a ojo" basándose en lo que cobraron
                hace un año, olvidando que la inflación y los imprevistos se
                están comiendo su ganancia viva.
              </p>
            </div>
            <div className="flex items-start gap-3" data-id="element-75">
              <AlertTriangleIcon className="w-6 h-6 flex-shrink-0 mt-1" style={{
              color: '#EF4444'
            }} data-id="element-76" />
              <p className="text-base md:text-lg leading-relaxed" style={{
              color: '#CBD5E1'
            }} data-id="element-77">
                Estás{' '}
                <strong style={{
                color: '#EF4444'
              }} data-id="element-78">
                  "comprando trabajo"
                </strong>{' '}
                en lugar de vender un servicio. Si tu cuenta de banco sube y
                baja como una montaña rusa,{' '}
                <strong style={{
                color: '#FFFFFF'
              }} data-id="element-79">
                  no tienes un negocio; tienes un autoempleo mal pagado que te
                  está robando el tiempo con tu familia.
                </strong>
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* AMBER DIVIDER */}
      <div className="w-full h-1" style={{
      background: 'linear-gradient(90deg, transparent, #F59E0B, transparent)'
    }} data-id="element-80" />

      {/* WHY WHAT YOU TRIED DIDN'T WORK */}
      <section className="w-full px-4 py-14" style={{
      backgroundColor: '#0F172A'
    }} data-id="element-81">
        <div className="max-w-2xl mx-auto" data-id="element-82">
          <div className="text-xs font-bold uppercase tracking-widest mb-4 text-center" style={{
          color: '#F59E0B',
          fontFamily: 'Oswald, sans-serif'
        }} data-id="element-83">
            El problema real
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-10 uppercase" style={{
          fontFamily: 'Oswald, sans-serif',
          color: '#FFFFFF'
        }} data-id="element-84">
            Por qué lo que intentaste
            <br data-id="element-85" />
            no funcionó
          </h2>

          <div className="space-y-4" data-id="element-86">
            <div className="flex items-start gap-4 p-5 rounded-xl" style={{
            backgroundColor: '#1E293B',
            border: '1px solid #2D3F55'
          }} data-id="element-87">
              <XCircleIcon className="w-6 h-6 flex-shrink-0 mt-0.5" style={{
              color: '#EF4444'
            }} data-id="element-88" />
              <div data-id="element-89">
                <p className="font-semibold mb-1" style={{
                color: '#FFFFFF',
                fontFamily: 'Inter, sans-serif'
              }} data-id="element-90">
                  Trabajar más horas
                </p>
                <p className="text-sm leading-relaxed" style={{
                color: '#94A3B8'
              }} data-id="element-91">
                  Solo te deja más cansado, no más rico, porque tus gastos
                  operativos crecen con el volumen.
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4 p-5 rounded-xl" style={{
            backgroundColor: '#1E293B',
            border: '1px solid #2D3F55'
          }} data-id="element-92">
              <XCircleIcon className="w-6 h-6 flex-shrink-0 mt-0.5" style={{
              color: '#EF4444'
            }} data-id="element-93" />
              <div data-id="element-94">
                <p className="font-semibold mb-1" style={{
                color: '#FFFFFF',
                fontFamily: 'Inter, sans-serif'
              }} data-id="element-95">
                  Bajar tus precios para "asegurar el trabajo"
                </p>
                <p className="text-sm leading-relaxed" style={{
                color: '#94A3B8'
              }} data-id="element-96">
                  Le dice al cliente que tu maestría no vale nada y te atrae a
                  los clientes más tóxicos.
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4 p-5 rounded-xl" style={{
            backgroundColor: '#1E293B',
            border: '1px solid #2D3F55'
          }} data-id="element-97">
              <XCircleIcon className="w-6 h-6 flex-shrink-0 mt-0.5" style={{
              color: '#EF4444'
            }} data-id="element-98" />
              <div data-id="element-99">
                <p className="font-semibold mb-1" style={{
                color: '#FFFFFF',
                fontFamily: 'Inter, sans-serif'
              }} data-id="element-100">
                  Confiar en la palabra del cliente para cambios extra
                </p>
                <p className="text-sm leading-relaxed" style={{
                color: '#94A3B8'
              }} data-id="element-101">
                  Hace que regales miles de dólares en labor y materiales cada
                  año sin darte cuenta.
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4 p-5 rounded-xl" style={{
            backgroundColor: '#1E293B',
            border: '1px solid #2D3F55'
          }} data-id="element-102">
              <XCircleIcon className="w-6 h-6 flex-shrink-0 mt-0.5" style={{
              color: '#EF4444'
            }} data-id="element-103" />
              <div data-id="element-104">
                <p className="font-semibold mb-1" style={{
                color: '#FFFFFF',
                fontFamily: 'Inter, sans-serif'
              }} data-id="element-105">
                  Mezclar tu cuenta personal con la del negocio
                </p>
                <p className="text-sm leading-relaxed" style={{
                color: '#94A3B8'
              }} data-id="element-106">
                  Te impide ver cuánto dinero estás perdiendo realmente hoy
                  mismo.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* AMBER DIVIDER */}
      <div className="w-full h-1" style={{
      background: 'linear-gradient(90deg, transparent, #F59E0B, transparent)'
    }} data-id="element-107" />

      {/* UNIQUE MECHANISM */}
      <section className="w-full px-4 py-16 relative overflow-hidden" style={{
      background: 'linear-gradient(135deg, #1E293B 0%, #0F172A 100%)'
    }} data-id="element-108">
        <div className="absolute inset-0 opacity-5" style={{
        backgroundImage: 'repeating-linear-gradient(45deg, #F59E0B 0, #F59E0B 1px, transparent 0, transparent 50%)',
        backgroundSize: '20px 20px'
      }} data-id="element-109" />
        <div className="max-w-2xl mx-auto relative z-10" data-id="element-110">
          <div className="text-xs font-bold uppercase tracking-widest mb-4 text-center" style={{
          color: '#F59E0B',
          fontFamily: 'Oswald, sans-serif'
        }} data-id="element-111">
            La solución
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-4 uppercase" style={{
          fontFamily: 'Oswald, sans-serif',
          color: '#FFFFFF'
        }} data-id="element-112">
            El Protocolo 30/30/40
          </h2>
          <p className="text-center mb-10 text-base" style={{
          color: '#94A3B8',
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-113">
            Una ley de hierro financiera diseñada para el mercado de
            construcción en EE.UU.
          </p>

          {/* Protocol breakdown */}
          <div className="grid grid-cols-3 gap-3 mb-10" data-id="element-114">
            <div className="rounded-xl p-5 text-center" style={{
            backgroundColor: '#0F172A',
            border: '2px solid #2D3F55'
          }} data-id="element-115">
              <div className="text-4xl font-bold mb-2" style={{
              fontFamily: 'Oswald, sans-serif',
              color: '#60A5FA'
            }} data-id="element-116">
                30%
              </div>
              <div className="text-xs font-semibold uppercase tracking-wide mb-2" style={{
              color: '#60A5FA'
            }} data-id="element-117">
                Materiales
              </div>
              <p className="text-xs leading-relaxed" style={{
              color: '#94A3B8'
            }} data-id="element-118">
                Costo exacto de todos los materiales del proyecto
              </p>
            </div>

            <div className="rounded-xl p-5 text-center" style={{
            backgroundColor: '#0F172A',
            border: '2px solid #2D3F55'
          }} data-id="element-119">
              <div className="text-4xl font-bold mb-2" style={{
              fontFamily: 'Oswald, sans-serif',
              color: '#A78BFA'
            }} data-id="element-120">
                30%
              </div>
              <div className="text-xs font-semibold uppercase tracking-wide mb-2" style={{
              color: '#A78BFA'
            }} data-id="element-121">
                Labor
              </div>
              <p className="text-xs leading-relaxed" style={{
              color: '#94A3B8'
            }} data-id="element-122">
                Sueldos, subcontratistas y tu tiempo de supervisión
              </p>
            </div>

            <div className="rounded-xl p-5 text-center" style={{
            backgroundColor: '#0F172A',
            border: '2px solid #F59E0B'
          }} data-id="element-123">
              <div className="text-4xl font-bold mb-2" style={{
              fontFamily: 'Oswald, sans-serif',
              color: '#F59E0B'
            }} data-id="element-124">
                40%
              </div>
              <div className="text-xs font-semibold uppercase tracking-wide mb-2" style={{
              color: '#F59E0B'
            }} data-id="element-125">
                Margen del Patriarca
              </div>
              <p className="text-xs leading-relaxed" style={{
              color: '#94A3B8'
            }} data-id="element-126">
                Gastos fijos, herramientas y tu ganancia neta protegida
              </p>
            </div>
          </div>

          <div className="rounded-xl p-6 border-l-4 mb-8" style={{
          backgroundColor: '#0F172A',
          borderLeftColor: '#F59E0B'
        }} data-id="element-127">
            <p className="text-base md:text-lg leading-relaxed" style={{
            color: '#CBD5E1'
          }} data-id="element-128">
              El 40% es el{' '}
              <strong style={{
              color: '#F59E0B'
            }} data-id="element-129">
                "Margen del Patriarca"
              </strong>
              : dinero reservado exclusivamente para tus gastos fijos,
              herramientas y, lo más importante, tu ganancia neta.{' '}
              <strong style={{
              color: '#FFFFFF'
            }} data-id="element-130">
                Si los números no dan para proteger ese 40%, el proyecto no se
                hace.
              </strong>
            </p>
          </div>

          <div className="flex justify-center" data-id="element-131">
            <button onClick={handleCTA} className="w-full max-w-md py-5 px-8 rounded-xl text-xl font-bold uppercase tracking-wide transition-all duration-200 active:scale-95" style={{
            backgroundColor: '#F59E0B',
            color: '#0F172A',
            fontFamily: 'Oswald, sans-serif',
            fontWeight: 800
          }} data-id="element-132">
              QUIERO APLICAR ESTE PROTOCOLO →
            </button>
          </div>
        </div>
      </section>

      {/* AMBER DIVIDER */}
      <div className="w-full h-1" style={{
      background: 'linear-gradient(90deg, transparent, #F59E0B, transparent)'
    }} data-id="element-133" />

      {/* WHAT YOU GET */}
      <section className="w-full px-4 py-14" style={{
      backgroundColor: '#1E293B'
    }} data-id="element-134">
        <div className="max-w-2xl mx-auto" data-id="element-135">
          <div className="text-xs font-bold uppercase tracking-widest mb-4 text-center" style={{
          color: '#F59E0B',
          fontFamily: 'Oswald, sans-serif'
        }} data-id="element-136">
            Lo que recibes hoy
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-10 uppercase" style={{
          fontFamily: 'Oswald, sans-serif',
          color: '#FFFFFF'
        }} data-id="element-137">
            Todo lo que incluye
            <br data-id="element-138" />
            el sistema
          </h2>
          <div className="flex items-start gap-3 rounded-xl p-4 mb-8" style={{
          backgroundColor: 'rgba(245, 158, 11, 0.08)',
          border: '1px solid rgba(245, 158, 11, 0.3)'
        }} data-id="element-139">
            <AlertTriangleIcon className="w-5 h-5 flex-shrink-0 mt-0.5" style={{
            color: '#F59E0B'
          }} data-id="element-140" />
            <p className="text-sm leading-relaxed" style={{
            color: '#CBD5E1',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-141">
              <strong style={{
              color: '#F59E0B'
            }} data-id="element-142">
                Nota importante:
              </strong>{' '}
              El precio promocional de{' '}
              <strong style={{
              color: '#FFFFFF'
            }} data-id="element-143">
                $6.35
              </strong>{' '}
              aplica únicamente al Manual Maestro Contratista Master. Los bonos
              adicionales mostrados en la imagen{' '}
              <strong style={{
              color: '#FFFFFF'
            }} data-id="element-144">
                no están incluidos
              </strong>{' '}
              en esta oferta de lanzamiento.
            </p>
          </div>
          <div className="space-y-4" data-id="element-145">
            <div className="flex items-start gap-4 p-5 rounded-xl" style={{
            backgroundColor: '#0F172A',
            border: '1px solid #2D3F55'
          }} data-id="element-146">
              <div className="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0" style={{
              backgroundColor: 'rgba(245, 158, 11, 0.15)'
            }} data-id="element-147">
                <FileTextIcon className="w-5 h-5" style={{
                color: '#F59E0B'
              }} data-id="element-148" />
              </div>
              <div data-id="element-149">
                <p className="font-bold mb-1" style={{
                color: '#FFFFFF',
                fontFamily: 'Oswald, sans-serif',
                fontSize: '1.1rem'
              }} data-id="element-150">
                  Manual Maestro "Contratista Master" (PDF)
                </p>
                <p className="text-sm leading-relaxed" style={{
                color: '#94A3B8'
              }} data-id="element-151">
                  La estrategia completa paso a paso para blindar tu negocio de
                  construcción.
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4 p-5 rounded-xl" style={{
            backgroundColor: '#0F172A',
            border: '1px solid #2D3F55'
          }} data-id="element-152">
              <div className="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0" style={{
              backgroundColor: 'rgba(245, 158, 11, 0.15)'
            }} data-id="element-153">
                <CalculatorIcon className="w-5 h-5" style={{
                color: '#F59E0B'
              }} data-id="element-154" />
              </div>
              <div data-id="element-155">
                <p className="font-bold mb-1" style={{
                color: '#FFFFFF',
                fontFamily: 'Oswald, sans-serif',
                fontSize: '1.1rem'
              }} data-id="element-156">
                  Calculador de Margen Real
                </p>
                <p className="text-sm leading-relaxed" style={{
                color: '#94A3B8'
              }} data-id="element-157">
                  La fórmula exacta para presupuestar materiales y labor sin
                  errores. Úsala desde tu teléfono.
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4 p-5 rounded-xl" style={{
            backgroundColor: '#0F172A',
            border: '1px solid #2D3F55'
          }} data-id="element-158">
              <div className="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0" style={{
              backgroundColor: 'rgba(245, 158, 11, 0.15)'
            }} data-id="element-159">
                <MessageSquareIcon className="w-5 h-5" style={{
                color: '#F59E0B'
              }} data-id="element-160" />
              </div>
              <div data-id="element-161">
                <p className="font-bold mb-1" style={{
                color: '#FFFFFF',
                fontFamily: 'Oswald, sans-serif',
                fontSize: '1.1rem'
              }} data-id="element-162">
                  Guía de Objeciones
                </p>
                <p className="text-sm leading-relaxed" style={{
                color: '#94A3B8'
              }} data-id="element-163">
                  Qué decir cuando el cliente dice "está muy caro" para cerrar
                  la venta con autoridad.
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4 p-5 rounded-xl" style={{
            backgroundColor: '#0F172A',
            border: '1px solid #2D3F55'
          }} data-id="element-164">
              <div className="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0" style={{
              backgroundColor: 'rgba(245, 158, 11, 0.15)'
            }} data-id="element-165">
                <ClipboardListIcon className="w-5 h-5" style={{
                color: '#F59E0B'
              }} data-id="element-166" />
              </div>
              <div data-id="element-167">
                <p className="font-bold mb-1" style={{
                color: '#FFFFFF',
                fontFamily: 'Oswald, sans-serif',
                fontSize: '1.1rem'
              }} data-id="element-168">
                  Plantilla de Orden de Cambio
                </p>
                <p className="text-sm leading-relaxed" style={{
                color: '#94A3B8'
              }} data-id="element-169">
                  El documento legal sencillo para cobrar cada clavo extra que
                  el cliente pida. Sin discusiones.
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4 p-5 rounded-xl" style={{
            backgroundColor: '#0F172A',
            border: '1px solid #2D3F55'
          }} data-id="element-170">
              <div className="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0" style={{
              backgroundColor: 'rgba(245, 158, 11, 0.15)'
            }} data-id="element-171">
                <ShieldCheckIcon className="w-5 h-5" style={{
                color: '#F59E0B'
              }} data-id="element-172" />
              </div>
              <div data-id="element-173">
                <p className="font-bold mb-1" style={{
                color: '#FFFFFF',
                fontFamily: 'Oswald, sans-serif',
                fontSize: '1.1rem'
              }} data-id="element-174">
                  Checklist de Cierre (Walk-through)
                </p>
                <p className="text-sm leading-relaxed" style={{
                color: '#94A3B8'
              }} data-id="element-175">
                  El protocolo para asegurar que el cheque final se entregue sin
                  excusas ni demoras.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* AMBER DIVIDER */}
      <div className="w-full h-1" style={{
      background: 'linear-gradient(90deg, transparent, #F59E0B, transparent)'
    }} data-id="element-176" />

      {/* WHO IT'S FOR / NOT FOR */}
      <section className="w-full px-4 py-14" style={{
      backgroundColor: '#0F172A'
    }} data-id="element-177">
        <div className="max-w-2xl mx-auto" data-id="element-178">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-10 uppercase" style={{
          fontFamily: 'Oswald, sans-serif',
          color: '#FFFFFF'
        }} data-id="element-179">
            ¿Este sistema es para ti?
          </h2>

          <div className="grid md:grid-cols-2 gap-6" data-id="element-180">
            {/* FOR */}
            <div className="rounded-xl p-6" style={{
            backgroundColor: '#1E293B',
            border: '2px solid #22C55E'
          }} data-id="element-181">
              <h3 className="text-xl font-bold mb-5 uppercase flex items-center gap-2" style={{
              fontFamily: 'Oswald, sans-serif',
              color: '#22C55E'
            }} data-id="element-182">
                <CheckCircleIcon className="w-5 h-5" data-id="element-183" />
                SÍ es para ti si eres...
              </h3>
              <ul className="space-y-3" data-id="element-184">
                <li className="flex items-start gap-3" data-id="element-185">
                  <CheckCircleIcon className="w-5 h-5 flex-shrink-0 mt-0.5" style={{
                  color: '#22C55E'
                }} data-id="element-186" />
                  <span className="text-sm leading-relaxed" style={{
                  color: '#CBD5E1'
                }} data-id="element-187">
                    Instalador de pisos, pintor, techador o remodelador
                    independiente
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-188">
                  <CheckCircleIcon className="w-5 h-5 flex-shrink-0 mt-0.5" style={{
                  color: '#22C55E'
                }} data-id="element-189" />
                  <span className="text-sm leading-relaxed" style={{
                  color: '#CBD5E1'
                }} data-id="element-190">
                    Dueño de pequeña compañía de construcción con cuadrillas de
                    2 a 5 personas
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-191">
                  <CheckCircleIcon className="w-5 h-5 flex-shrink-0 mt-0.5" style={{
                  color: '#22C55E'
                }} data-id="element-192" />
                  <span className="text-sm leading-relaxed" style={{
                  color: '#CBD5E1'
                }} data-id="element-193">
                    Contratista que siente que el dinero "se le escapa de las
                    manos" al final del mes
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-194">
                  <CheckCircleIcon className="w-5 h-5 flex-shrink-0 mt-0.5" style={{
                  color: '#22C55E'
                }} data-id="element-195" />
                  <span className="text-sm leading-relaxed" style={{
                  color: '#CBD5E1'
                }} data-id="element-196">
                    Hombre que quiere profesionalizar su oficio y construir un
                    legado real en EE.UU.
                  </span>
                </li>
              </ul>
            </div>

            {/* NOT FOR */}
            <div className="rounded-xl p-6" style={{
            backgroundColor: '#1E293B',
            border: '2px solid #EF4444'
          }} data-id="element-197">
              <h3 className="text-xl font-bold mb-5 uppercase flex items-center gap-2" style={{
              fontFamily: 'Oswald, sans-serif',
              color: '#EF4444'
            }} data-id="element-198">
                <XCircleIcon className="w-5 h-5" data-id="element-199" />
                NO es para ti si...
              </h3>
              <ul className="space-y-3" data-id="element-200">
                <li className="flex items-start gap-3" data-id="element-201">
                  <XCircleIcon className="w-5 h-5 flex-shrink-0 mt-0.5" style={{
                  color: '#EF4444'
                }} data-id="element-202" />
                  <span className="text-sm leading-relaxed" style={{
                  color: '#CBD5E1'
                }} data-id="element-203">
                    Buscas dinero fácil sin trabajar; esto requiere disciplina
                    operativa
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-204">
                  <XCircleIcon className="w-5 h-5 flex-shrink-0 mt-0.5" style={{
                  color: '#EF4444'
                }} data-id="element-205" />
                  <span className="text-sm leading-relaxed" style={{
                  color: '#CBD5E1'
                }} data-id="element-206">
                    Eres una gran corporación con departamentos de contabilidad
                    masivos
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-207">
                  <XCircleIcon className="w-5 h-5 flex-shrink-0 mt-0.5" style={{
                  color: '#EF4444'
                }} data-id="element-208" />
                  <span className="text-sm leading-relaxed" style={{
                  color: '#CBD5E1'
                }} data-id="element-209">
                    No estás dispuesto a decir "No" a un mal cliente
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* AMBER DIVIDER */}
      <div className="w-full h-1" style={{
      background: 'linear-gradient(90deg, transparent, #F59E0B, transparent)'
    }} data-id="element-210" />

      {/* HOW IT WORKS */}
      <section className="w-full px-4 py-14" style={{
      backgroundColor: '#1E293B'
    }} data-id="element-211">
        <div className="max-w-2xl mx-auto" data-id="element-212">
          <div className="text-xs font-bold uppercase tracking-widest mb-4 text-center" style={{
          color: '#F59E0B',
          fontFamily: 'Oswald, sans-serif'
        }} data-id="element-213">
            Tan simple como 1, 2, 3
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-10 uppercase" style={{
          fontFamily: 'Oswald, sans-serif',
          color: '#FFFFFF'
        }} data-id="element-214">
            Cómo funciona
          </h2>

          <div className="space-y-6" data-id="element-215">
            <div className="flex items-start gap-5" data-id="element-216">
              <div className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0 text-xl font-bold" style={{
              backgroundColor: '#F59E0B',
              color: '#0F172A',
              fontFamily: 'Oswald, sans-serif'
            }} data-id="element-217">
                1
              </div>
              <div className="pt-2" data-id="element-218">
                <p className="font-bold text-lg mb-1" style={{
                color: '#FFFFFF',
                fontFamily: 'Oswald, sans-serif'
              }} data-id="element-219">
                  DESCARGA EL MANUAL Y LAS PLANTILLAS
                </p>
                <p className="text-sm leading-relaxed" style={{
                color: '#94A3B8'
              }} data-id="element-220">
                  Acceso inmediato en tu celular o computadora. Todo en un solo
                  lugar, listo para usar.
                </p>
              </div>
            </div>

            <div className="flex items-start gap-5" data-id="element-221">
              <div className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0 text-xl font-bold" style={{
              backgroundColor: '#F59E0B',
              color: '#0F172A',
              fontFamily: 'Oswald, sans-serif'
            }} data-id="element-222">
                2
              </div>
              <div className="pt-2" data-id="element-223">
                <p className="font-bold text-lg mb-1" style={{
                color: '#FFFFFF',
                fontFamily: 'Oswald, sans-serif'
              }} data-id="element-224">
                  APLICA EL CALCULADOR EN TU PRÓXIMO PRESUPUESTO
                </p>
                <p className="text-sm leading-relaxed" style={{
                color: '#94A3B8'
              }} data-id="element-225">
                  Te tomará solo 10 minutos. Sabrás exactamente cuánto ganarás
                  antes de empezar el trabajo.
                </p>
              </div>
            </div>

            <div className="flex items-start gap-5" data-id="element-226">
              <div className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0 text-xl font-bold" style={{
              backgroundColor: '#F59E0B',
              color: '#0F172A',
              fontFamily: 'Oswald, sans-serif'
            }} data-id="element-227">
                3
              </div>
              <div className="pt-2" data-id="element-228">
                <p className="font-bold text-lg mb-1" style={{
                color: '#FFFFFF',
                fontFamily: 'Oswald, sans-serif'
              }} data-id="element-229">
                  USA LA ORDEN DE CAMBIO ANTE CUALQUIER PEDIDO EXTRA
                </p>
                <p className="text-sm leading-relaxed" style={{
                color: '#94A3B8'
              }} data-id="element-230">
                  Asegura tu ganancia en cada cambio. Sin discusiones, sin
                  regalos, sin sorpresas.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* AMBER DIVIDER */}
      <div className="w-full h-1" style={{
      background: 'linear-gradient(90deg, transparent, #F59E0B, transparent)'
    }} data-id="element-231" />

      {/* PROOF / BELIEVABILITY */}
      <section className="w-full px-4 py-14" style={{
      backgroundColor: '#0F172A'
    }} data-id="element-232">
        <div className="max-w-2xl mx-auto" data-id="element-233">
          <div className="text-xs font-bold uppercase tracking-widest mb-4 text-center" style={{
          color: '#F59E0B',
          fontFamily: 'Oswald, sans-serif'
        }} data-id="element-234">
            Lo que verás en 7 días
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-8 uppercase" style={{
          fontFamily: 'Oswald, sans-serif',
          color: '#FFFFFF'
        }} data-id="element-235">
            Resultados reales,
            <br data-id="element-236" />
            matemáticas de negocio
          </h2>

          <div className="rounded-xl p-6 md:p-8 mb-8" style={{
          backgroundColor: '#1E293B',
          border: '2px solid #F59E0B'
        }} data-id="element-237">
            <div className="flex items-start gap-3 mb-4" data-id="element-238">
              <TrendingUpIcon className="w-6 h-6 flex-shrink-0 mt-1" style={{
              color: '#F59E0B'
            }} data-id="element-239" />
              <p className="text-base md:text-lg leading-relaxed" style={{
              color: '#CBD5E1'
            }} data-id="element-240">
                En los próximos{' '}
                <strong style={{
                color: '#F59E0B'
              }} data-id="element-241">
                  7 días
                </strong>
                , verás cómo tus presupuestos suben de valor percibido.
              </p>
            </div>
            <div className="flex items-start gap-3" data-id="element-242">
              <ShieldCheckIcon className="w-6 h-6 flex-shrink-0 mt-1" style={{
              color: '#22C55E'
            }} data-id="element-243" />
              <p className="text-base md:text-lg leading-relaxed" style={{
              color: '#CBD5E1'
            }} data-id="element-244">
                Al aplicar el Protocolo 30/30/40 en tu siguiente obra, sabrás
                exactamente{' '}
                <strong style={{
                color: '#FFFFFF'
              }} data-id="element-245">
                  cuántos dólares te quedan de ganancia neta antes de empezar el
                  trabajo.
                </strong>{' '}
                No más adivinanzas, solo matemáticas de negocio.
              </p>
            </div>
          </div>

          <div className="grid grid-cols-3 gap-4 text-center" data-id="element-246">
            <div className="rounded-xl p-4" style={{
            backgroundColor: '#1E293B',
            border: '1px solid #2D3F55'
          }} data-id="element-247">
              <div className="text-3xl font-bold mb-1" style={{
              fontFamily: 'Oswald, sans-serif',
              color: '#F59E0B'
            }} data-id="element-248">
                30%
              </div>
              <div className="text-xs" style={{
              color: '#94A3B8'
            }} data-id="element-249">
                Margen neto garantizado
              </div>
            </div>
            <div className="rounded-xl p-4" style={{
            backgroundColor: '#1E293B',
            border: '1px solid #2D3F55'
          }} data-id="element-250">
              <div className="text-3xl font-bold mb-1" style={{
              fontFamily: 'Oswald, sans-serif',
              color: '#F59E0B'
            }} data-id="element-251">
                10min
              </div>
              <div className="text-xs" style={{
              color: '#94A3B8'
            }} data-id="element-252">
                Para presupuestar correctamente
              </div>
            </div>
            <div className="rounded-xl p-4" style={{
            backgroundColor: '#1E293B',
            border: '1px solid #2D3F55'
          }} data-id="element-253">
              <div className="text-3xl font-bold mb-1" style={{
              fontFamily: 'Oswald, sans-serif',
              color: '#F59E0B'
            }} data-id="element-254">
                $0
              </div>
              <div className="text-xs" style={{
              color: '#94A3B8'
            }} data-id="element-255">
                En trabajo regalado
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* AMBER DIVIDER */}
      <div className="w-full h-1" style={{
      background: 'linear-gradient(90deg, transparent, #F59E0B, transparent)'
    }} data-id="element-256" />

      {/* FAQ */}
      <section className="w-full px-4 py-14" style={{
      backgroundColor: '#1E293B'
    }} data-id="element-257">
        <div className="max-w-2xl mx-auto" data-id="element-258">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-10 uppercase" style={{
          fontFamily: 'Oswald, sans-serif',
          color: '#FFFFFF'
        }} data-id="element-259">
            Preguntas frecuentes
          </h2>

          <div className="space-y-3" data-id="element-260">
            {faqs.map((faq, index) => <div key={index} className="rounded-xl overflow-hidden" style={{
            backgroundColor: '#0F172A',
            border: '1px solid #2D3F55'
          }} data-id="element-261">
                <button onClick={() => toggleFaq(index)} className="w-full flex items-center justify-between p-5 text-left transition-colors duration-200" style={{
              color: '#FFFFFF'
            }} aria-expanded={openFaq === index} data-id="element-262">
                  <span className="font-semibold text-base pr-4" style={{
                fontFamily: 'Inter, sans-serif'
              }} data-id="element-263">
                    {faq.question}
                  </span>
                  {openFaq === index ? <ChevronUpIcon className="w-5 h-5 flex-shrink-0" style={{
                color: '#F59E0B'
              }} data-id="element-264" /> : <ChevronDownIcon className="w-5 h-5 flex-shrink-0" style={{
                color: '#F59E0B'
              }} data-id="element-265" />}
                </button>
                {openFaq === index && <div className="px-5 pb-5" style={{
              borderTop: '1px solid #2D3F55'
            }} data-id="element-266">
                    <p className="text-sm leading-relaxed pt-4" style={{
                color: '#94A3B8',
                fontFamily: 'Inter, sans-serif'
              }} data-id="element-267">
                      {faq.answer}
                    </p>
                  </div>}
              </div>)}
          </div>
        </div>
      </section>

      {/* AMBER DIVIDER */}
      <div className="w-full h-1" style={{
      background: 'linear-gradient(90deg, transparent, #F59E0B, transparent)'
    }} data-id="element-268" />

      {/* OFFER + PRICE BLOCK + FINAL CTA */}
      <section id="offer" className="w-full px-4 py-16 relative overflow-hidden" style={{
      background: 'linear-gradient(180deg, #0F172A 0%, #1E293B 100%)'
    }} data-id="element-269">
        <div className="absolute inset-0 opacity-5" style={{
        backgroundImage: 'linear-gradient(#F59E0B 1px, transparent 1px), linear-gradient(90deg, #F59E0B 1px, transparent 1px)',
        backgroundSize: '40px 40px'
      }} data-id="element-270" />
        <div className="max-w-2xl mx-auto relative z-10" data-id="element-271">
          {/* Product image */}
          <div className="flex justify-center mb-8" data-id="element-272">
            <img src="https://cdn.magicpatterns.com/uploads/dR46B7XDc1whSqG6HM1ksp/Mockup_Contratista_Master.png" alt="Manual Contratista Master" className="w-full max-w-xs rounded-xl" style={{
            filter: 'drop-shadow(0 20px 60px rgba(245, 158, 11, 0.3))'
          }} data-id="element-273" />
          </div>

          <h2 className="text-3xl md:text-4xl font-bold text-center mb-4 uppercase" style={{
          fontFamily: 'Oswald, sans-serif',
          color: '#FFFFFF'
        }} data-id="element-274">
            Protege el futuro de tu negocio
            <br data-id="element-275" />y la estabilidad de tu familia
          </h2>
          <p className="text-center mb-8 text-base leading-relaxed" style={{
          color: '#94A3B8',
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-276">
            El conocimiento contenido en este manual te ahorrará miles de
            dólares en errores de presupuesto en tu primer mes.
          </p>

          {/* Price card */}
          <div className="rounded-2xl p-8 mb-8 text-center" style={{
          backgroundColor: '#1E293B',
          border: `2px solid ${isUrgent ? '#EF4444' : '#F59E0B'}`,
          boxShadow: isUrgent ? '0 0 40px rgba(239,68,68,0.25)' : '0 0 40px rgba(245, 158, 11, 0.2)',
          animation: isUrgent ? 'flash-border 0.8s ease-in-out infinite' : 'none'
        }} data-id="element-277">
            <div className="inline-block px-4 py-1 rounded-full text-sm font-bold uppercase tracking-wider mb-4" style={{
            backgroundColor: 'rgba(245, 158, 11, 0.15)',
            color: '#F59E0B',
            fontFamily: 'Oswald, sans-serif'
          }} data-id="element-278">
              Precio Especial de Lanzamiento
            </div>

            {/* Countdown inside price card */}
            <div className="flex items-center justify-center gap-3 mb-5 px-4 py-3 rounded-xl" style={{
            backgroundColor: isUrgent ? 'rgba(239,68,68,0.12)' : 'rgba(245,158,11,0.08)',
            border: `1px solid ${isUrgent ? '#EF4444' : 'rgba(245,158,11,0.4)'}`
          }} data-id="element-279">
              <ClockIcon className="w-5 h-5 flex-shrink-0" style={{
              color: isUrgent ? '#EF4444' : '#F59E0B'
            }} data-id="element-280" />
              <div data-id="element-281">
                <p className="text-xs uppercase tracking-wider mb-0.5" style={{
                color: '#64748B',
                fontFamily: 'Inter, sans-serif'
              }} data-id="element-282">
                  {isUrgent ? '⚠️ ¡OFERTA EXPIRANDO!' : 'Esta oferta expira en'}
                </p>
                <span className="text-2xl font-bold tabular-nums" style={{
                fontFamily: 'Oswald, sans-serif',
                color: isUrgent ? '#EF4444' : '#F59E0B',
                letterSpacing: '0.1em'
              }} data-id="element-283">
                  {minutes}:{seconds}
                </span>
              </div>
            </div>

            {/* Pricing */}
            <div className="mb-1 flex items-center justify-center gap-3 flex-wrap" data-id="element-284">
              <span className="text-2xl line-through" style={{
              color: '#64748B',
              fontFamily: 'Oswald, sans-serif'
            }} data-id="element-285">
                $49.99
              </span>
              <span className="text-sm font-bold px-3 py-1 rounded-full uppercase" style={{
              backgroundColor: '#EF4444',
              color: '#FFFFFF',
              fontFamily: 'Oswald, sans-serif'
            }} data-id="element-286">
                87% DESCUENTO — Ahorras $43.64
              </span>
            </div>
            <div className="mb-2" data-id="element-287">
              <span className="font-bold" style={{
              fontFamily: 'Oswald, sans-serif',
              color: '#F59E0B',
              fontSize: '5rem',
              lineHeight: 1
            }} data-id="element-288">
                $6.35
              </span>
              <span className="text-2xl ml-2" style={{
              color: '#94A3B8',
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-289">
                USD
              </span>
            </div>
            <p className="text-sm mb-6" style={{
            color: '#94A3B8'
          }} data-id="element-290">
              Pago único • Acceso de por vida • Sin suscripciones
            </p>

            {/* What's included recap */}
            <div className="text-left space-y-2 mb-8" data-id="element-291">
              <div className="flex items-center gap-3" data-id="element-292">
                <CheckCircleIcon className="w-5 h-5 flex-shrink-0" style={{
                color: '#22C55E'
              }} data-id="element-293" />
                <span className="text-sm" style={{
                color: '#CBD5E1'
              }} data-id="element-294">
                  Manual Maestro "Contratista Master" (PDF)
                </span>
              </div>
              <div className="flex items-center gap-3" data-id="element-295">
                <CheckCircleIcon className="w-5 h-5 flex-shrink-0" style={{
                color: '#22C55E'
              }} data-id="element-296" />
                <span className="text-sm" style={{
                color: '#CBD5E1'
              }} data-id="element-297">
                  Calculador de Margen Real
                </span>
              </div>
              <div className="flex items-center gap-3" data-id="element-298">
                <CheckCircleIcon className="w-5 h-5 flex-shrink-0" style={{
                color: '#22C55E'
              }} data-id="element-299" />
                <span className="text-sm" style={{
                color: '#CBD5E1'
              }} data-id="element-300">
                  Guía de Objeciones
                </span>
              </div>
              <div className="flex items-center gap-3" data-id="element-301">
                <CheckCircleIcon className="w-5 h-5 flex-shrink-0" style={{
                color: '#22C55E'
              }} data-id="element-302" />
                <span className="text-sm" style={{
                color: '#CBD5E1'
              }} data-id="element-303">
                  Plantilla de Orden de Cambio
                </span>
              </div>
              <div className="flex items-center gap-3" data-id="element-304">
                <CheckCircleIcon className="w-5 h-5 flex-shrink-0" style={{
                color: '#22C55E'
              }} data-id="element-305" />
                <span className="text-sm" style={{
                color: '#CBD5E1'
              }} data-id="element-306">
                  Checklist de Cierre (Walk-through)
                </span>
              </div>
            </div>

            {/* Main CTA Button */}
            <a href="https://proyectopatriarca.com/cart/48931418341616:1" target="_blank" rel="noopener noreferrer" onClick={handleAddToCart} className="w-full py-6 px-8 rounded-xl text-xl font-bold uppercase tracking-wide transition-all duration-200 active:scale-95 mb-4 cta-pulse flex items-center justify-center" style={{
            backgroundColor: '#F59E0B',
            color: '#0F172A',
            fontFamily: 'Oswald, sans-serif',
            fontWeight: 800,
            fontSize: '1.3rem',
            letterSpacing: '0.05em',
            textDecoration: 'none',
            display: 'flex'
          }} data-id="element-307">
              QUIERO SER UN CONTRATISTA MASTER
            </a>

            {/* Trust signals */}
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 text-xs" style={{
            color: '#64748B'
          }} data-id="element-308">
              <div className="flex items-center gap-1.5" data-id="element-309">
                <LockIcon className="w-4 h-4" style={{
                color: '#22C55E'
              }} data-id="element-310" />
                <span data-id="element-311">Pago seguro y encriptado</span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-312">
                <DownloadIcon className="w-4 h-4" style={{
                color: '#22C55E'
              }} data-id="element-313" />
                <span data-id="element-314">Acceso inmediato tras la compra</span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-315">
                <ClockIcon className="w-4 h-4" style={{
                color: '#22C55E'
              }} data-id="element-316" />
                <span data-id="element-317">Disponible 24/7 en tu dispositivo</span>
              </div>
            </div>
          </div>

          {/* Urgency reminder */}
          <div className="rounded-xl p-4 text-center" style={{
          backgroundColor: 'rgba(245, 158, 11, 0.1)',
          border: '1px solid rgba(245, 158, 11, 0.3)'
        }} data-id="element-318">
            <p className="text-sm font-semibold" style={{
            color: '#F59E0B'
          }} data-id="element-319">
              ⚡ Este precio de lanzamiento es temporal. No dejes que otro
              contratista tome ventaja antes que tú.
            </p>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="w-full px-4 py-8 text-center" style={{
      backgroundColor: '#0F172A',
      borderTop: '1px solid #1E293B'
    }} data-id="element-320">
        <p className="text-xs" style={{
        color: '#475569'
      }} data-id="element-321">
          © 2025 Contratista Master. Todos los derechos reservados.
        </p>
        <p className="text-xs mt-2" style={{
        color: '#475569'
      }} data-id="element-322">
          Los resultados pueden variar. Este producto es material educativo
          diseñado para contratistas independientes.
        </p>
        <div className="flex items-center justify-center gap-4 mt-4" data-id="element-323">
          <button onClick={() => setOpenModal('privacy')} className="text-xs underline underline-offset-2 transition-colors duration-150" style={{
          color: '#64748B',
          fontFamily: 'Inter, sans-serif'
        }} onMouseEnter={e => e.currentTarget.style.color = '#F59E0B'} onMouseLeave={e => e.currentTarget.style.color = '#64748B'} data-id="element-324">
            Política de Privacidad
          </button>
          <span style={{
          color: '#334155'
        }} data-id="element-325">
            |
          </span>
          <button onClick={() => setOpenModal('terms')} className="text-xs underline underline-offset-2 transition-colors duration-150" style={{
          color: '#64748B',
          fontFamily: 'Inter, sans-serif'
        }} onMouseEnter={e => e.currentTarget.style.color = '#F59E0B'} onMouseLeave={e => e.currentTarget.style.color = '#64748B'} data-id="element-326">
            Términos y Condiciones
          </button>
        </div>
      </footer>

      {/* MODAL OVERLAY */}
      {openModal && <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center p-0 sm:p-4" style={{
      backgroundColor: 'rgba(0,0,0,0.75)'
    }} onClick={() => setOpenModal(null)} data-id="element-327">
          <div className="w-full sm:max-w-2xl max-h-[90vh] overflow-y-auto rounded-t-2xl sm:rounded-2xl" style={{
        backgroundColor: '#1E293B',
        border: '1px solid #2D3F55',
        boxShadow: '0 0 60px rgba(0,0,0,0.6)'
      }} onClick={e => e.stopPropagation()} data-id="element-328">
            {/* Modal Header */}
            <div className="flex items-center justify-between px-6 py-5 sticky top-0" style={{
          backgroundColor: '#1E293B',
          borderBottom: '1px solid #2D3F55'
        }} data-id="element-329">
              <h2 className="text-xl font-bold uppercase" style={{
            fontFamily: 'Oswald, sans-serif',
            color: '#FFFFFF'
          }} data-id="element-330">
                {openModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
              </h2>
              <button onClick={() => setOpenModal(null)} className="w-8 h-8 rounded-full flex items-center justify-center transition-colors duration-150" style={{
            backgroundColor: '#0F172A',
            color: '#94A3B8'
          }} onMouseEnter={e => e.currentTarget.style.backgroundColor = '#F59E0B'} onMouseLeave={e => e.currentTarget.style.backgroundColor = '#0F172A'} aria-label="Cerrar" data-id="element-331">
                <XCircleIcon className="w-5 h-5" data-id="element-332" />
              </button>
            </div>

            {/* Modal Body */}
            <div className="px-6 py-6 space-y-5 text-sm leading-relaxed" style={{
          color: '#94A3B8',
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-333">
              {openModal === 'privacy' && <>
                  <p style={{
              color: '#CBD5E1'
            }} data-id="element-334">
                    Última actualización: enero 2025
                  </p>
                  <div data-id="element-335">
                    <h3 className="font-bold mb-2 uppercase" style={{
                color: '#F59E0B',
                fontFamily: 'Oswald, sans-serif'
              }} data-id="element-336">
                      1. Información que recopilamos
                    </h3>
                    <p data-id="element-337">
                      Al realizar una compra en este sitio, recopilamos
                      únicamente la información necesaria para procesar tu
                      pedido: nombre, dirección de correo electrónico y datos de
                      pago. Los datos de pago son procesados de forma segura por
                      nuestro proveedor de pagos y nunca son almacenados en
                      nuestros servidores.
                    </p>
                  </div>
                  <div data-id="element-338">
                    <h3 className="font-bold mb-2 uppercase" style={{
                color: '#F59E0B',
                fontFamily: 'Oswald, sans-serif'
              }} data-id="element-339">
                      2. Uso de la información
                    </h3>
                    <p data-id="element-340">
                      Utilizamos tu información exclusivamente para: (a)
                      procesar y entregar tu compra, (b) enviarte el acceso al
                      material digital adquirido, y (c) comunicaciones
                      relacionadas con tu pedido. No utilizamos tu información
                      para fines publicitarios de terceros.
                    </p>
                  </div>
                  <div data-id="element-341">
                    <h3 className="font-bold mb-2 uppercase" style={{
                color: '#F59E0B',
                fontFamily: 'Oswald, sans-serif'
              }} data-id="element-342">
                      3. Compartir información
                    </h3>
                    <p data-id="element-343">
                      No vendemos, alquilamos ni compartimos tu información
                      personal con terceros, excepto cuando sea estrictamente
                      necesario para procesar tu pago o cumplir con obligaciones
                      legales.
                    </p>
                  </div>
                  <div data-id="element-344">
                    <h3 className="font-bold mb-2 uppercase" style={{
                color: '#F59E0B',
                fontFamily: 'Oswald, sans-serif'
              }} data-id="element-345">
                      4. Seguridad
                    </h3>
                    <p data-id="element-346">
                      Implementamos medidas de seguridad estándar de la
                      industria para proteger tu información. Todas las
                      transacciones se realizan a través de conexiones
                      encriptadas (SSL/TLS).
                    </p>
                  </div>
                  <div data-id="element-347">
                    <h3 className="font-bold mb-2 uppercase" style={{
                color: '#F59E0B',
                fontFamily: 'Oswald, sans-serif'
              }} data-id="element-348">
                      5. Cookies
                    </h3>
                    <p data-id="element-349">
                      Este sitio puede utilizar cookies técnicas necesarias para
                      el funcionamiento básico de la página. No utilizamos
                      cookies de seguimiento publicitario de terceros.
                    </p>
                  </div>
                  <div data-id="element-350">
                    <h3 className="font-bold mb-2 uppercase" style={{
                color: '#F59E0B',
                fontFamily: 'Oswald, sans-serif'
              }} data-id="element-351">
                      6. Tus derechos
                    </h3>
                    <p data-id="element-352">
                      Tienes derecho a solicitar el acceso, corrección o
                      eliminación de tu información personal en cualquier
                      momento. Para ejercer estos derechos, puedes enviarnos un
                      mensaje a través de los canales de soporte disponibles
                      tras tu compra.
                    </p>
                  </div>
                </>}

              {openModal === 'terms' && <>
                  <p style={{
              color: '#CBD5E1'
            }} data-id="element-353">
                    Última actualización: enero 2025
                  </p>
                  <div data-id="element-354">
                    <h3 className="font-bold mb-2 uppercase" style={{
                color: '#F59E0B',
                fontFamily: 'Oswald, sans-serif'
              }} data-id="element-355">
                      1. Descripción del producto
                    </h3>
                    <p data-id="element-356">
                      Contratista Master es un producto de información digital
                      (PDF y plantillas) diseñado con fines educativos para
                      contratistas independientes. El acceso se entrega de forma
                      inmediata tras la confirmación del pago.
                    </p>
                  </div>
                  <div data-id="element-357">
                    <h3 className="font-bold mb-2 uppercase" style={{
                color: '#F59E0B',
                fontFamily: 'Oswald, sans-serif'
              }} data-id="element-358">
                      2. Pago único y acceso de por vida
                    </h3>
                    <p data-id="element-359">
                      La compra consiste en un pago único que otorga acceso de
                      por vida al material. No existen cargos recurrentes,
                      suscripciones ni costos ocultos asociados a este producto.
                    </p>
                  </div>
                  <div data-id="element-360">
                    <h3 className="font-bold mb-2 uppercase" style={{
                color: '#F59E0B',
                fontFamily: 'Oswald, sans-serif'
              }} data-id="element-361">
                      3. Uso permitido
                    </h3>
                    <p data-id="element-362">
                      El material adquirido es para uso personal y profesional
                      exclusivo del comprador. Queda estrictamente prohibida la
                      reproducción, distribución, reventa o compartición del
                      contenido con terceros sin autorización escrita.
                    </p>
                  </div>
                  <div data-id="element-363">
                    <h3 className="font-bold mb-2 uppercase" style={{
                color: '#F59E0B',
                fontFamily: 'Oswald, sans-serif'
              }} data-id="element-364">
                      4. Política de reembolsos
                    </h3>
                    <p data-id="element-365">
                      Dado que se trata de un producto digital con entrega
                      inmediata, no se ofrecen reembolsos una vez que el acceso
                      ha sido entregado. Al completar la compra, el usuario
                      acepta esta condición expresamente.
                    </p>
                  </div>
                  <div data-id="element-366">
                    <h3 className="font-bold mb-2 uppercase" style={{
                color: '#F59E0B',
                fontFamily: 'Oswald, sans-serif'
              }} data-id="element-367">
                      5. Descargo de responsabilidad
                    </h3>
                    <p data-id="element-368">
                      Los resultados descritos en este sitio son ejemplos
                      ilustrativos y no garantizan resultados específicos. Los
                      resultados individuales variarán según la aplicación, el
                      mercado local y otros factores fuera de nuestro control.
                      Este producto es material educativo y no constituye
                      asesoría legal, contable o financiera profesional.
                    </p>
                  </div>
                  <div data-id="element-369">
                    <h3 className="font-bold mb-2 uppercase" style={{
                color: '#F59E0B',
                fontFamily: 'Oswald, sans-serif'
              }} data-id="element-370">
                      6. Modificaciones
                    </h3>
                    <p data-id="element-371">
                      Nos reservamos el derecho de actualizar estos términos en
                      cualquier momento. El uso continuado del producto implica
                      la aceptación de los términos vigentes.
                    </p>
                  </div>
                  <div data-id="element-372">
                    <h3 className="font-bold mb-2 uppercase" style={{
                color: '#F59E0B',
                fontFamily: 'Oswald, sans-serif'
              }} data-id="element-373">
                      7. Ley aplicable
                    </h3>
                    <p data-id="element-374">
                      Estos términos se rigen por las leyes aplicables en los
                      Estados Unidos de América. Cualquier disputa será resuelta
                      de buena fe entre las partes.
                    </p>
                  </div>
                </>}
            </div>

            {/* Modal Footer */}
            <div className="px-6 py-4 flex justify-center" style={{
          borderTop: '1px solid #2D3F55'
        }} data-id="element-375">
              <button onClick={() => setOpenModal(null)} className="px-8 py-3 rounded-xl font-bold uppercase text-sm transition-all duration-150 active:scale-95" style={{
            backgroundColor: '#F59E0B',
            color: '#0F172A',
            fontFamily: 'Oswald, sans-serif'
          }} data-id="element-376">
                Entendido
              </button>
            </div>
          </div>
        </div>}
    </div>;
}